var $16125922964febca$exports = {};
$16125922964febca$exports = {
    "breadcrumbs": `Drobtine`
};


export {$16125922964febca$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
